import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { SwimlaneTitle } from '../../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { MediaTeaser } from '../../../components/Teaser/MediaTeaser/MediaTeaser';
import { MediaTeaserPlaceholder } from '../../../components/Teaser/MediaTeaser/MediaTeaserPlaceholder';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useContinueWatching } from '../../../providers/VideoHistoryProvider/use-continue-watching';
import { useVideoHistory } from '../../../providers/VideoHistoryProvider/VideoHistoryContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ContinueWatching = () => {
  const {
    t
  } = useTranslation();
  const [wasIntersecting, setWasIntersecting] = useState(false);
  const drawContent = wasIntersecting;
  const {
    videos,
    error,
    isLoading
  } = useContinueWatching();
  const {
    continueWatchingIds
  } = useVideoHistory();
  const {
    usePreview
  } = useVideoConfig();
  const showSwimlane = !error && continueWatchingIds.length > 0 || isLoading || usePreview;
  return /*#__PURE__*/_jsx(Fragment, {
    children: showSwimlane && /*#__PURE__*/_jsxs(Swimlane, {
      onIntersectionChanged: isIntersecting => {
        if (isIntersecting) {
          setWasIntersecting(isIntersecting);
        }
      },
      children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
        title: t('global.continueWatching')
      }), /*#__PURE__*/_jsx(Swipeable, {
        buttonPositionFactor: 9 / 16,
        placeholder: /*#__PURE__*/_jsx(MediaTeaserPlaceholder, {}),
        isPersonalized: true,
        analyticsTitle: "ContinueWatching",
        children: drawContent && videos?.map((video, index) => /*#__PURE__*/_jsx(MediaTeaser, {
          media: video,
          index: index,
          labelOrder: ['expiringSoon']
        }, video.id))
      })]
    })
  });
};